<app-navigation-bar [topNavigationLinks]="topNavigationLinks$ | async"></app-navigation-bar>
